import { render, staticRenderFns } from "./numberstep2.vue?vue&type=template&id=bf50865e&scoped=true&"
import script from "./numberstep2.vue?vue&type=script&lang=js&"
export * from "./numberstep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf50865e",
  null
  
)

export default component.exports